var _ellipse, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 11.5,
    rx: 4,
    ry: 1.66667,
    stroke: "black",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.83333,
    r: 2,
    stroke: "black",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29665 9.34099C3.47093 9.37535 2.71243 9.5241 2.12362 9.75962C1.78715 9.89421 1.48131 10.067 1.2514 10.2844C1.02044 10.5028 0.833008 10.8008 0.833008 11.1667C0.833008 11.5325 1.02044 11.8305 1.2514 12.0489C1.48131 12.2664 1.78715 12.4391 2.12362 12.5737C2.45682 12.707 2.84435 12.8125 3.26765 12.8852C2.93857 12.5302 2.73202 12.1336 2.67958 11.713C2.61528 11.6913 2.5537 11.6687 2.49501 11.6452C2.22827 11.5385 2.04596 11.424 1.93851 11.3224C1.83288 11.2225 1.833 11.1697 1.83301 11.1667L1.83301 11.1667L1.83301 11.1666C1.833 11.1636 1.83288 11.1109 1.93851 11.011C2.04596 10.9093 2.22827 10.7948 2.49501 10.6881C2.63032 10.634 2.78101 10.5844 2.94492 10.5405C3.22072 10.0806 3.68932 9.67065 4.29665 9.34099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3202 11.713C13.2678 12.1336 13.0612 12.5302 12.7321 12.8852C13.1554 12.8125 13.543 12.707 13.8762 12.5737C14.2126 12.4391 14.5185 12.2664 14.7484 12.0489C14.9793 11.8305 15.1668 11.5325 15.1668 11.1667C15.1668 10.8008 14.9793 10.5028 14.7484 10.2844C14.5185 10.067 14.2126 9.89421 13.8762 9.75962C13.2873 9.5241 12.5288 9.37535 11.7031 9.34099C12.3105 9.67065 12.7791 10.0806 13.0549 10.5405C13.2188 10.5844 13.3695 10.634 13.5048 10.6881C13.7715 10.7948 13.9538 10.9093 14.0613 11.011C14.1669 11.1109 14.1668 11.1636 14.1668 11.1666V11.1667V11.1667C14.1668 11.1697 14.1669 11.2225 14.0613 11.3224C13.9538 11.424 13.7715 11.5385 13.5048 11.6452C13.4461 11.6687 13.3845 11.6913 13.3202 11.713Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0091 7.26811C10.8626 7.57506 10.6704 7.85606 10.4414 8.10237C10.7053 8.2495 11.0093 8.33333 11.3329 8.33333C12.3454 8.33333 13.1662 7.51252 13.1662 6.5C13.1662 5.48748 12.3454 4.66667 11.3329 4.66667C11.2634 4.66667 11.1948 4.67054 11.1273 4.67807C11.2419 4.98848 11.3118 5.32064 11.3288 5.66668C11.3302 5.66667 11.3315 5.66667 11.3329 5.66667C11.7931 5.66667 12.1662 6.03976 12.1662 6.5C12.1662 6.96024 11.7931 7.33333 11.3329 7.33333C11.2181 7.33333 11.1087 7.31011 11.0091 7.26811Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87197 4.67807C4.80447 4.67054 4.73586 4.66667 4.66634 4.66667C3.65382 4.66667 2.83301 5.48748 2.83301 6.5C2.83301 7.51252 3.65382 8.33333 4.66634 8.33333C4.98992 8.33333 5.29393 8.2495 5.55782 8.10237C5.32884 7.85606 5.13667 7.57506 4.99008 7.26812C4.89055 7.31012 4.78116 7.33333 4.66634 7.33333C4.2061 7.33333 3.83301 6.96024 3.83301 6.5C3.83301 6.03976 4.2061 5.66667 4.66634 5.66667C4.66771 5.66667 4.66907 5.66667 4.67043 5.66668C4.68747 5.32064 4.75728 4.98848 4.87197 4.67807Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers02);
export default __webpack_public_path__ + "static/media/users 02.84e7ed996975295252d4624b4252a2de.svg";
export { ForwardRef as ReactComponent };